// Import packages
import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {Form, Modal} from "react-bootstrap";

// Import assets
import './addRole.scss';
import {CloseIcon, DownIcon, InformationIcon} from "../../../../../../image";

// Import Utils
import {getPropsFromState} from "../../../../../../redux/mapStateToProps";
import {ClearRoleById, CreateRole, GetAuthCheck, GetReisRoles, UpdateRole} from "../../../../../../redux/actions";
import {useTranslation} from "react-i18next";
import {
    ROLE_ITEMS,
    rolePermissions, rolePermissionsTooltip,
    rolesName, roleTooltipText
} from "../../../../../../utils/constants";
import DropdownMenu from "../../../../../../shared/features/dropdownMenu";
import config from "../../../../../../utils/config";
import {Tooltip} from "antd";
import {MarkDownText} from "../../../../../../shared/features/MarkDownText";
import {hasPermission} from "../../../../../../utils/helperFunctions";

const initialState = {
    name: undefined,
    description: undefined,
    reis_role_ids: [],
    permissions: [],
}
const initialErrors = {
    name: false,
    description: false,
    permissions: false,
}

function AddRole(props) {
    const {show, setEditedRole, editedRole, GetRoleById, ClearRoleById, roleById, reisList} = props;

    const {t, i18n} = useTranslation();

    const [roleInfo, setRoleInfo] = useState(initialState);
    const [errors, setErrors] = useState(initialErrors);
    const [haveChanges, setHaveChanges] = useState(new Map());
    const [userPermissions, setUserPermissions] = useState([]);


    let disabledBtn = !!Object.values(roleInfo).find(item => !!item)?.length && hasPermission(ROLE_ITEMS.ROLES_CREATE)

    useEffect(() => {
        if (editedRole?.id) {
            GetRoleById(editedRole?.id)
        }
    }, [editedRole])

    useEffect(() => {
        if (roleById?.id) {
            let list = []
            list = [...roleById?.permissions]
            setUserPermissions(list)

            setRoleInfo({
                ...roleInfo,
                name: roleById?.name,
                description: roleById?.description,
                permissions: list,
                reis_role_ids: roleById?.reis_roles?.map(item => item?.id)
            })
        }
        props.GetReisRoles()
    }, [roleById])

    function clearHaveChanges() {
        const changes = new Map(haveChanges);
        changes.clear()
        setHaveChanges(changes)
    }

    function getInputValue(e) {
        const {name, value} = e.target
        setRoleInfo({
            ...roleInfo,
            [name]: value
        })

        const changes = new Map(haveChanges);
        if (roleById?.[name] !== value) {
            changes.set(name, value)
        } else {
            changes.delete(name)
        }
        setHaveChanges(changes)
    }

    function toggleCheck(permission) {
        let list = roleInfo.permissions

        if (list?.includes(permission)) {
            list = list.filter(i => i !== permission)
        } else {
            list = [...list, permission]
        }

        setRoleInfo({
            ...roleInfo,
            permissions: list
        })

        const changes = new Map(haveChanges);

        if (userPermissions?.sort()?.toString() !== list?.sort()?.toString()) {
            changes.set('permissions', list)
        } else {
            changes.delete('permissions')
        }
        setHaveChanges(changes)
    }

    const permissionNonPersonal = [
        ROLE_ITEMS.FOREIGN_VIDEOS_MAIN_PROPERTIES_EDIT,
        ROLE_ITEMS.FOREIGN_VIDEOS_AI_TEXT_EDIT,
        ROLE_ITEMS.FOREIGN_VIDEO_FAVORITES_EDIT,
        ROLE_ITEMS.FOREIGN_VIDEO_SHARING_EDIT,
        ROLE_ITEMS.FOREIGN_VIDEO_CHAINS_FULL_ACCESS,
    ]

    function toggleCheckAll(permission) {

        let list = roleInfo.permissions

        if (list?.includes(permission)) {
            list = list.filter(i => i !== permission)
        } else {
            list = [...list, permission].filter((item)=> !permissionNonPersonal.includes(item))
        }

        setRoleInfo({
            ...roleInfo,
            permissions: list
        })

        const changes = new Map(haveChanges);

        if (userPermissions?.sort()?.toString() !== list?.sort()?.toString()) {
            changes.set('permissions', list)
        } else {
            changes.delete('permissions')
        }
        setHaveChanges(changes)
    }

    function validateData(data) {
        const {name} = data
        setErrors(initialErrors)
        let isValid = true;
        let errorList = {...initialErrors}

        if (!name?.length || name?.length < 2) {
            isValid = false
            errorList = {
                ...errorList,
                name: t('error_name')
            }
        }

        setErrors(errorList)

        return isValid
    }

    function saveChanges() {
        const recData = {
            name: roleInfo.name,
        };
        let checkedList = []

        checkedList = [...checkedList.filter(i => i.includes('all')), ...roleInfo.permissions]
        roleInfo?.description && (recData.description = roleInfo.description)
        !!roleInfo?.reis_role_ids?.length && (recData.reis_role_ids = roleInfo.reis_role_ids)
        !!checkedList?.length && (recData.permissions = checkedList)

        if (validateData(recData)) {
            roleById?.id
                ? props.UpdateRole(roleById?.id, recData)
                : props.CreateRole(recData)
            props.GetAuthCheck()
            onClose()
        }
    }

    function onClose() {
        setRoleInfo(initialState)
        setErrors(initialErrors)
        setEditedRole(undefined)
        ClearRoleById()
        clearHaveChanges()
        props.closeModal()
    }

    function checkReis(reis) {
        const list = !roleInfo?.reis_role_ids?.includes(reis?.id)
            ? [...roleInfo?.reis_role_ids, reis?.id]
            : roleInfo?.reis_role_ids.filter(i => i !== reis?.id)

        setRoleInfo({
            ...roleInfo,
            reis_role_ids: list
        })

        const changes = new Map(haveChanges);

        const reis_roles = roleById?.reis_roles?.map(i => i.id)
        if (reis_roles?.sort()?.toString() !== list?.sort()?.toString()) {
            changes.set('reis_role_ids', list)
        } else {
            changes.delete('reis_role_ids')
        }
        setHaveChanges(changes)
    }
    const isMax = config.productName.includes('max')
    let rolesNames = []

    !!reisList?.length && reisList.forEach(item => {
        if (roleInfo.reis_role_ids?.includes(item.id)) {
            rolesNames.push(item?.name)
        }
    })

    return <Modal
        show={show}
        onHide={onClose}
        size="xl"
        centered
        className={'role_modal'}
    >
        <div className="role_modal__wrap">
            <div className="role_modal__title">
                {roleById?.id ? t('edit_role'):  t('add_role')}
                <CloseIcon onClick={onClose}/>
            </div>

            <div className="input_group">
                <label htmlFor="">{t('roles_input_name')}</label>
                <input type="text"
                       value={roleInfo?.name}
                       autoComplete={'off'}
                       disabled={!hasPermission(ROLE_ITEMS.ROLES_CREATE)}
                       name={'name'}
                       onChange={getInputValue}
                       placeholder={t('roles_input_name')}
                />
                {!!errors.name && (
                    <div className="input_group__error">{errors.name}</div>
                )}
            </div>

            {isMax && <div className="select_group">
                <label htmlFor="">{t('roles_input_description_label')}</label>
                <DropdownMenu button={
                    <button className="reis-btn">
                        {!rolesNames.length ? t('roles_input_description')
                            : <span className="reis-btn__name">
                                {rolesNames?.[0]}
                                {rolesNames?.length > 1 &&
                                    <span className="reis-count">+{rolesNames?.length - 1}</span>}
                        </span>}

                        <DownIcon className="speakers-arrow"/>
                    </button>
                }
                              closeAfterToggle={false}
                              className={'reis-select'}
                              contentWidth={'100%'}>
                    <Form>
                        {
                            !!reisList?.length && reisList?.map((item) => {
                                return <div className="reis-select__item"
                                            key={item?.id}>
                                    <Form.Check
                                        className="reis-select__item__check"
                                        type={'checkbox'}
                                        checked={roleInfo?.reis_role_ids?.includes(item?.id)}
                                        onChange={() => {
                                            checkReis(item)
                                        }}
                                    />
                                    <div className="reis-select__item__name">
                                        {item?.name}
                                    </div>
                                </div>
                            })
                        }
                    </Form>

                </DropdownMenu>

                {rolesNames?.length > 1 && <div className="select_group__list">
                    {
                        rolesNames?.map(item => {
                            return <div className="reis-item" key={item}>
                                {item}

                            </div>
                        })
                    }
                </div>}

                {/*{!!errors.description && (*/}
                {/*    <div className="input_group__error">{errors.description}</div>*/}
                {/*)}*/}

            </div>}

            <div className="role_modal__permissions">
                {
                    Object.entries(rolePermissions(i18n.language)).map(([key, value]) => {
                        return <div className="permission_item" key={key}>
                            <div className="permission_item__title">
                                {key}
                                {rolePermissionsTooltip(i18n.language)?.[key]?
                                  <Tooltip
                                    placement="top"
                                    overlayClassName={"permission-tooltip"}
                                    overlayInnerStyle={{ padding: '8px 16px'}}
                                    title={
                                        <MarkDownText
                                          className="notification-item"
                                          text={rolePermissionsTooltip(i18n.language)?.[key]}
                                        />
                                    }
                                  >
                                      <InformationIcon/>
                                  </Tooltip>
                                  : null}
                            </div>

                            <Form>
                                {
                                    value?.map(item => {
                                        let label = item.split('_')
                                        label = rolesName(i18n.language)[item]

                                        return <div className="permission_item__item">
                                            <Form.Check
                                              name="type"
                                              key={item}
                                              label={label || item}
                                              type={'checkbox'}
                                              checked={!!roleInfo.permissions.includes(item)}
                                              disabled={roleInfo.permissions?.includes(ROLE_ITEMS.FOREIGN_VIDEOS_FULL_ACCESS) && permissionNonPersonal.includes(item)}
                                              onChange={() => {
                                                  if(item === ROLE_ITEMS.FOREIGN_VIDEOS_FULL_ACCESS) {
                                                      toggleCheckAll(item)
                                                  } else {
                                                      toggleCheck(item)
                                                  }
                                              }}
                                            />
                                            {roleTooltipText(i18n.language)?.[item] ?
                                                <Tooltip
                                                  placement="top"
                                                  overlayClassName={"permission-tooltip"}
                                                  overlayInnerStyle={{ padding: '8px 16px'}}
                                                  title={
                                                      <MarkDownText
                                                        className="notification-item"
                                                        text={roleTooltipText(i18n.language)?.[item]}
                                                      />
                                                  }
                                                >
                                                    <InformationIcon/>
                                                </Tooltip>
                                              : null
                                            }
                                        </div>
                                    })
                                }

                            </Form>
                        </div>
                    })
                }

            </div>

            <div className="role_modal__buttons">
                <button className={`close_btn`}
                        onClick={onClose}
                >
                    {t('button_cancel')}
                </button>

                {
                    !!roleById?.id ? <button className={`save_btn ${!haveChanges.size ? 'disabled' : ''}`}
                                             disabled={!haveChanges.size}
                                             onClick={saveChanges}
                        >
                            {t('button_save')}
                        </button>
                        : <button className={`save_btn ${!disabledBtn ? 'disabled' : ''}`}
                                  disabled={!disabledBtn}
                                  onClick={saveChanges}
                        >
                            {t('button_save')}
                        </button>
                }

            </div>
        </div>
    </Modal>
}

const mapStateToProps = (state) => {
    return getPropsFromState(state, ['reisList'])
};

const mapDispatchToProps = {
    CreateRole,
    ClearRoleById,
    UpdateRole,
    GetAuthCheck,
    GetReisRoles,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddRole);
